module.exports = __webpack_public_path__ + "img/15.97e983e7.jpg";